/**
 * Part of datavideo project.
 *
 * @copyright  Copyright (C) 2022 __ORGANIZATION__.
 * @license    __LICENSE__
 */

u.directive('youtube-sm-cover', {
  async mounted(el, { value }) {
    const img = new Image();
    img.onload = (e) => {
      if (img.height < 200) {
        el.src = value;
      }
    };
    img.src = el.src;
  }
});
